/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_FC as FC,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_IC_73_67(e) {
  let t = (0, ReactCompiler.c)(2),
    { ancho: n, alto: r } = e,
    i = `${FC} ${n === void 0 ? `w-full` : n} ${r === void 0 ? `h-3` : r}`,
    a;
  return (
    t[0] === i
      ? (a = t[1])
      : ((a = <div className={i} />), (t[0] = i), (t[1] = a)),
    a
  );
}
